import type {TestOccurrenceId} from '../../../../types'
import CopyIconButton from '../../../common/CopyIconButton/CopyIconButton'
import {getTestOccurrence} from '../Tests.selectors'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  iconClassName?: string
  testOccurrenceId?: TestOccurrenceId
}

function CopyTestNameIconButton({testOccurrenceId, ...restProps}: Props) {
  const testOccurrence = useAppSelector(state => getTestOccurrence(state, testOccurrenceId))
  const {testPackage, testClass, testNameWithParameters} =
    testOccurrence?.test?.parsedTestName ?? {}

  const fullTestName =
    [testPackage, testClass, testNameWithParameters].filter(Boolean).join('.') ||
    testOccurrence?.name ||
    ''
  return (
    <CopyIconButton {...restProps} text={fullTestName} title="Copy full test name to clipboard" />
  )
}

export default CopyTestNameIconButton
